import {
  PortfolioTransactionAddStoreModuleFactory,
  PortfolioTransactionAddStoreModuleComponentDependencies,
  FactsheetHeaderAdditionalDataType,
  FactsheetHeaderStoreModuleFactory,
  FactsheetHeaderStoreModuleComponentDependencies,
  CompanyLogoStoreModuleFactory,
  inheritEndpointOptions,
} from "@fds/wm-typescript-poc-waap-stores-mdg2";
import { EgbMarketSelectorStoreModuleFactory } from "@/overrides/EgbMarketSelectorStoreModuleFactory";

export class EgbPortfolioTransactionAddStoreModuleFactory extends PortfolioTransactionAddStoreModuleFactory {
  public getDependencies(): PortfolioTransactionAddStoreModuleComponentDependencies {
    if (!this.dependencies) {
      const endpointConfiguration = this.options?.endpointConfiguration;
      const genericAdditionalData: FactsheetHeaderAdditionalDataType[] = [
        "isin",
        "wkn",
        "country",
      ];

      const factsheetHeader = new EgbFactsheetHeaderStoreModuleFactory({
        mdg2Client: this.mdg2Client,
        logger: this.logger,
        store: this.store,
        options: {
          assetClass: {
            generic: {
              additionalData: genericAdditionalData,
            },
          },
          ...inheritEndpointOptions(
            endpointConfiguration,
            this.options?.factsheetHeader
          ),
        },
      });
      this.dependencies = {
        factsheetHeader,
      };
    }
    return this.dependencies;
  }
}

export class EgbFactsheetHeaderStoreModuleFactory extends FactsheetHeaderStoreModuleFactory {
  public getDependencies(): FactsheetHeaderStoreModuleComponentDependencies {
    if (!this.dependencies) {
      const endpointConfiguration = this.options?.endpointConfiguration;
      this.dependencies = {
        companyLogo: new CompanyLogoStoreModuleFactory({
          mdg2Client: this.mdg2Client,
          logger: this.logger,
          store: this.store,
          options: inheritEndpointOptions(
            endpointConfiguration,
            this.options?.companyLogo
          ),
        }),
        marketSelector: new EgbMarketSelectorStoreModuleFactory({
          mdg2Client: this.mdg2Client,
          logger: this.logger,
          store: this.store,
          options: inheritEndpointOptions(
            endpointConfiguration,
            this.options?.marketSelector
          ),
        }),
      };
    }

    return this.dependencies;
  }
}
